module.exports = __webpack_public_path__ + "static/CentralPark_withDescriptions-cee9fa019928edda6fd3f4ed03176453.jpg";